import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'core-block-ui',
  templateUrl: './core-block-ui.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CoreBlockUiComponent {}
